import { render } from "./ViewCandidateProfile.vue?vue&type=template&id=a9e264d4"
import script from "./ViewCandidateProfile.vue?vue&type=script&lang=js"
export * from "./ViewCandidateProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__